export const SHARE_CREDIT_APP_LINK_CONTENT = {
    heading: 'Send a Secure Link',
    description: (buyerFirstName: string) => `Text or email a link so ${buyerFirstName} enters their own information.`,
    actionLabel: 'Send link'
};
